import { Text } from '@chakra-ui/react';
import { Tooltip } from '@/components/v4';
import appConfig from '../../config.json';

export const IGNORED_MESSAGE = 'Ignored, no changes detected.';
export const SUCCESS_MESSAGE = 'Success.';
export const CSV_TYPE = 'text/csv';
export const CSV_TYPE_ERROR = 'File must be .csv type';

export const trunkUsageDropdown = [
    { id: 'CallingUserAssignment', name: 'Calling User Assignment' },
    // {id: 'ConferenceAssignment', name: 'Conference Assignment'},
    { id: 'FirstPartyAppAssignment', name: 'First Party App Assignment' },
    // {id: 'ThirdPartyAppAssignment', name: 'Third Party App Assignment'},
];

export const ERROR_MESSAGE = 'Something went wrong. Please try again later.';

export const TRUNK_USAGE_VALUES = [
    'CallingUserAssignment',
    'FirstPartyAppAssignment',
];
export const TEMPLATE_FILENAME = 'NumbersUpdateTemplate.csv';

// export const VERIFICATION_CHECKS = [
//     {
//         label: 'Received CSV',
//         check: false,
//         current: true,
//         completionCounter: 0,
//         total: 1,
//     },
//     {
//         label: 'Fetching Company Data',
//         check: false,
//         current: false,
//         completionCounter: 0,
//         total: 4,
//     },
//     {
//         label: 'Converting CSV',
//         check: false,
//         current: false,
//         completionCounter: 0,
//         total: 3,
//     },
//     {
//         label: 'Verifying Numbers',
//         check: false,
//         current: false,
//         completionCounter: 0,
//         total: 2,
//     },
//     {
//         label: 'Verifying Trunks',
//         check: false,
//         current: false,
//         completionCounter: 0,
//         total: 2,
//     },
//     // {
//     //     label: 'Verifying Addresses',
//     //     check: false,
//     //     current: false,
//     //     completionCounter: 0,
//     //     total: 1,
//     // },
//     // {
//     //     label: 'Verifying Outbound Caller IDs',
//     //     check: false,
//     //     current: false,
//     //     completionCounter: 0,
//     //     total: 1,
//     // },
// ];
export const getVerificationChecks = (platformName) => {
    let verificationChecks = [
        {
            label: 'Received CSV',
            check: false,
            current: true,
            completionCounter: 0,
            total: 1,
        },
        {
            label: 'Fetching Company Data',
            check: false,
            current: false,
            completionCounter: 0,
            total: 4,
        },
        {
            label: 'Converting CSV',
            check: false,
            current: false,
            completionCounter: 0,
            total: 3,
        },
        {
            label: 'Verifying Numbers',
            check: false,
            current: false,
            completionCounter: 0,
            total: 2,
        },
    ];
    if (
        platformName !== 'Numbers' &&
        platformName !== 'Priority' &&
        platformName !== 'RingCentral'
    ) {
        verificationChecks.push({
            label: 'Verifying Trunks',
            check: false,
            current: false,
            completionCounter: 0,
            total: 2,
        });
    }
    if (platformName === 'Numbers') {
        verificationChecks.push({
            label: 'Verifying Addresses',
            check: false,
            current: false,
            completionCounter: 0,
            total: 1,
        });
        verificationChecks.push({
            label: 'Verifying Outbound Caller IDs',
            check: false,
            current: false,
            completionCounter: 0,
            total: 1,
        });
        verificationChecks.push({
            label: 'Validating Registrar',
            check: false,
            current: false,
            completionCounter: 0,
            total: 1,
        });
        verificationChecks.push({
            label: 'Validating Registration Name',
            check: false,
            current: false,
            completionCounter: 0,
            total: 1,
        });
    }

    return verificationChecks;
};
export const DEFAULT_VERIFICATION_RESULT = {
    passed: {
        columns: [],
        data: [],
    },
    failed: {
        columns: [],
        data: [],
    },
};

export const SHARED_FIELDS_TO_EXPORT = {
    numberID: 'Number ID',
    telephoneNumber: 'Telephone Number',
    cliPresentation: 'Outbound Caller ID',
    trunk: 'Trunk',
    operatorConnectCallingProfileID: 'Operator Connect Calling Profile',
    operatorConnectUsageID: 'Operator Connect Telephone Number Usage',
    // address: 'Address',
    overstampNumber: 'Overstamp Number',
    trsRegistration: 'TRS Registration',
    registrarName: 'Registrar Name',
    // attribute1: 'Attribute 1',
    // attribute2: 'Attribute 2',
    // attribute3: 'Attribute 3',
};
export const FIELDS_TO_EXPORT = {
    ...SHARED_FIELDS_TO_EXPORT,
    errors: 'Errors',
};

export const INVALID_FILENAME = 'InvalidNumbers.csv';
export const FAILED_FILENAME = 'FailedNumbers.csv';

// Required headers per platform type — validated on CSV upload
export const TEAMS_REQUIRED_HEADERS = [
    'Number ID',
    'Telephone Number',
    'Trunk',
    'Operator Connect Calling Profile',
    'Operator Connect Telephone Number Usage',
    'Overstamp Number',
];
export const GCCH_REQUIRED_HEADERS = [
    'Number ID',
    'Telephone Number',
    'Trunk',
    'Overstamp Number',
];
export const PRIORITY_REQUIRED_HEADERS = ['Telephone Number'];
export const NUMBERS_REQUIRED_HEADERS = [
    'Number ID',
    'Telephone Number',
    'Outbound Caller ID',
    'Plan',
    'Address',
    'Attribute 1',
    'Attribute 2',
    'Attribute 3',
    'TRS Registration',
    'Registrar Name',
];
export const RING_CENTRAL_REQUIRED_HEADERS = ['Number ID', 'Telephone Number'];

export const MISSING_HEADERS_ERROR = (missing) =>
    `CSV is missing required headers: ${missing.join(', ')}`;
export const NO_DATA_ROWS_ERROR = 'CSV must contain at least one data row.';

export const API_RESULT_FIELDS_TO_EXPORT = {
    ...SHARED_FIELDS_TO_EXPORT,
    apiErrors: 'Errors',
};

export const haveErrorsFilter = (v) => v.errors.length > 0;
export const isIgnoredFilter = (v) => v.ignored;

export const FIELDS_CHANGE_NEED_VALIDATION = [
    'trunk',
    // 'addressID',
    // 'cliPresentation',
    'operatorConnectCallingProfile',
    'operatorConnectUsageID',
];

export const FIELDS_CHANGE_NO_NEED_VALIDATION = [
    'overstampNumber',
    'attribute1',
    'attribute2',
    'attribute3',
    'plan',
];

export const additionalOutbound = [
    {
        telephoneNumber: 'Restricted',
    },
];

export const succeedAPIColumns = [
    {
        title: 'Telephone Number',
        field: 'telephoneNumber',
    },
];

export const succeedAPIColumnsWithPlatform = [
    {
        title: 'Telephone Number',
        field: 'telephoneNumber',
    },
    {
        title: 'Platform',
        field: 'platform',
    },
];

export const failedAPIColumns = [
    {
        title: 'Telephone Number',
        field: 'telephoneNumber',
    },
    {
        title: 'Failure Reasons',
        field: 'apiErrors',
    },
];

export const failedAPIColumnsWithPlatform = [
    {
        title: 'Telephone Number',
        field: 'telephoneNumber',
    },
    {
        title: 'Platform',
        field: 'platform',
    },
    {
        title: 'Failure Reasons',
        field: 'apiErrors',
    },
];

export const NUMBERS_DNE_ERROR =
    'This number ID does not exist in your company.';
export const NUMBER_NOT_OK_ERROR = 'This number is not in editable status.';
export const NO_DATA_FOUND_ERROR = "We didn't detect any changes.";
export const CSV_LIMIT_REACHED_ERROR = `Upload file contains more than ${appConfig.csvLimit} records.`;
export const CSV_LIMIT_REACHED_DESCRIPTION_ERROR = `If you need to add more than ${appConfig.csvLimit} entries, create and upload additional data files.`;
export const INVALID_CP_ERROR = 'This number has invalid Calling Profile.';
export const INVALID_TNU_ERROR =
    'This number has invalid Telephone Number Usage.';
export const TRUNKS_DNE_ERROR = 'This trunk does not exist in your company.';
export const ADDRESS_DNE_ERROR = 'This address does not exist in your company.';
export const ADDRESS_WRONG_ERROR = 'Cannot identify this address description.';
export const ADDRESS_CANNOT_ALLOCATED =
    'This address cannot be allocated to this number.';
export const OUTBOUND_DNE_ERROR =
    'This Outbound Caller ID does not exist in your company.';
export const INVALID_USER_PLAN_ERROR = 'This user plan is invalid.';
export const INVALID_PREFIX_ERROR = 'This prefix is invalid.';
export const INVALID_NUMBER_ALLOCATED_ERROR = 'This number is invalid.';
export const INVALID_PLAN_PERMISSIONS_ERROR =
    'You do not have permission to change the plan for this number.';
export const INVALID_TRS_REGISTRATION_ERROR =
    'TRS Registration does not exist or is invalid.';
export const INVALID_TRS_REGISTRAR_ERROR =
    'Registrar Name does not exist or is invalid.';
export const INVALID_TRS_NUMBER_UNAVAILABLE_ERROR =
    'This number is not available for TRS registration or is already assigned.';
export const INVALID_TRS_INCOMPLETE_ERROR =
    'Both TRS Registration and Registrar Name must be provided or both must be empty.';

export const defaultColumns = [
    {
        title: 'Telephone Number',
        field: 'telephoneNumber',
        defaultSort: 'asc',
    },

    // {
    //     title: 'Outbound Caller ID',
    //     field: 'cliPresentation',
    // },

    {
        title: 'Trunk',
        field: 'trunk',
    },
    {
        title: 'Calling Profile',
        field: 'operatorConnectCallingProfileID',
    },
    {
        title: 'Usage Type',
        field: 'operatorConnectUsageID',
    },
    // {
    //     title: 'Address',
    //     field: 'address',
    // },
    // {
    //     title: 'Custom Attribute 1',
    //     field: 'attribute1',
    // },
    // {
    //     title: 'Custom Attribute 2',
    //     field: 'attribute2',
    // },
    // {
    //     title: 'Custom Attribute 3',
    //     field: 'attribute3',
    // },
];

export const passedColumns = [
    {
        title: 'Telephone Number',
        field: 'telephoneNumber',
    },

    // {
    //     title: 'Outbound Caller ID',
    //     field: 'cliPresentation',
    // },

    {
        title: 'Trunk',
        field: 'trunk',
    },
    {
        title: 'Calling Profile',
        field: 'operatorConnectCallingProfileID',
    },
    {
        title: 'Usage Type',
        field: 'operatorConnectUsageID',
    },
    // {
    //     title: 'Address',
    //     field: 'address',
    // },
    // {
    //     title: 'Custom Attribute 1',
    //     field: 'attribute1',
    // },
    // {
    //     title: 'Custom Attribute 2',
    //     field: 'attribute2',
    // },
    // {
    //     title: 'Custom Attribute 3',
    //     field: 'attribute3',
    // },
    {
        title: 'Verification Status',
        field: 'verificationStatus',
    },
];

export const failedColumns = [
    ...defaultColumns,
    {
        title: 'Failure reasons',
        field: 'errors',
        width: '40%',
        cellRenderer: (params) => {
            const errors = params.data?.errors;
            if (Array.isArray(errors) && errors.length > 0) {
                const errorString = errors.join('\n');
                return (
                    <Tooltip label={errorString} hasArrow placement="top">
                        <span
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: 'block',
                                cursor: 'help',
                            }}>
                            {errorString}
                        </span>
                    </Tooltip>
                );
            }
            return params.value ?? null;
        },
    },
];
export const getColumns = (platformName) => {
    const baseColumns = [
        {
            title: 'Telephone Number',
            field: 'telephoneNumber',
            defaultSort: 'asc',
        },
    ];
    const platformSpecificColumns =
        platformName === 'Numbers'
            ? [
                  { title: 'Outbound Caller ID', field: 'cliPresentation' },
                  { title: 'Plan', field: 'plan' },
                  { title: 'Address', field: 'address' },
                  { title: 'Attribute 1', field: 'attribute1' },
                  { title: 'Attribute 2', field: 'attribute2' },
                  { title: 'Attribute 3', field: 'attribute3' },
                  { title: 'TRS Registration', field: 'trsRegistration' },
                  { title: 'Registrar Name', field: 'registrarName' },
              ]
            : platformName === 'Priority'
              ? [
                    { title: 'Priority', field: 'priority' },
                    { title: 'Platform', field: 'platform' },
                ]
              : platformName === '8x8'
                ? [
                      { title: 'Trunk', field: 'trunk' },
                      { title: 'Overstamp', field: 'overstampNumber' },
                  ]
                : platformName === 'RingCentral'
                  ? []
                  : [
                        { title: 'Trunk', field: 'trunk' },
                        {
                            title: 'Calling Profile',
                            field: 'operatorConnectCallingProfile',
                        },
                        {
                            title: 'Usage Type',
                            field: 'operatorConnectUsageID',
                        },
                    ];

    const defaultColumns = [...baseColumns, ...platformSpecificColumns];

    const passedColumns = [...baseColumns, ...platformSpecificColumns];

    const failedColumns = [
        ...baseColumns,
        ...platformSpecificColumns,
        {
            title: 'Failure reasons',
            field: 'errors',
            width: '40%',
            cellRenderer: (params) => {
                const errors = params.data?.errors;
                if (Array.isArray(errors) && errors.length > 0) {
                    const errorString = errors.join('\n');
                    return (
                        <Tooltip label={errorString} hasArrow placement="top">
                            <span
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    display: 'block',
                                    cursor: 'help',
                                }}>
                                {errorString}
                            </span>
                        </Tooltip>
                    );
                }
                return params.value ?? null;
            },
        },
    ];

    return { defaultColumns, passedColumns, failedColumns };
};
export const makeDateStr = () => {
    const now = new Date();
    const yy = String(now.getFullYear()).slice(2);
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const ss = String(now.getSeconds()).padStart(2, '0');
    return `${yy}${mm}${dd}_${hh}${min}${ss}`;
};

const slugify = (str) =>
    (str || '').replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');

// Matches the Users CSV export naming convention (useCSVUsers.js's
// buildUsersFilename), e.g. Acme_Numbers_Modified_Validation_260806_120000.csv
export const buildCompanyFilename = (
    companyName,
    platformName,
    type,
    phase,
) => {
    const companySlug = slugify(companyName) || 'Company';
    const platformSlug = slugify(platformName) || 'Numbers';
    return `${companySlug}_${platformSlug}_${type}_${phase}_${makeDateStr()}.csv`;
};

export const getInstructionsForPlatform = (platform, isUserPage = false) => {
    // If it's user page, return user-specific instructions
    if (isUserPage) {
        return [
            `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
            'Swapping numbers requires you to un-assign and then re-assign.',
            'Please ensure you keep the original CSV file, in case of data corruption.',
            'You are responsible for the changes you are about to make through this data import.',
        ];
    }

    // For numbers page, use platform-specific instructions
    const normalizedPlatform = platform?.toLowerCase().trim();

    switch (normalizedPlatform) {
        case 'microsoft teams':
        case 'microsoft acs':
            return [
                `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
                'Number IDs and Telephone Numbers cannot be edited.  ',
                'Overstamp Numbers are not validated.',
                'Please ensure you keep the original CSV file, in case of data corruption.',
                'For Operator Connect, please ensure the correct Calling Profile for the region/country is assigned. Failure to do so may result in issue making calls.',
            ];
        case 'zoom':
        case 'sbcaas':
            return [
                `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
                'Number IDs and Telephone Numbers cannot be edited.  ',
                'Overstamp Numbers are not validated.',
                'Please ensure you keep the original CSV file, in case of data corruption.',
            ];
        case 'ringcentral':
            return [
                `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
                'Number IDs and Telephone Numbers cannot be edited.',
                'Please ensure you keep the original CSV file, in case of data corruption.',
                'You are responsible for the changes you are about to make through this data import.',
            ];
        case 'eightbyeight':
            return [
                `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
                'Number ID and Telephone Number are required and cannot be edited.',
                'Overstamp is required. If Trunk is empty the number will be disabled.',
                'Please ensure you keep the original CSV file, in case of data corruption.',
            ];
        case 'priority':
            return [
                `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
                'Please note, not defining a priority on a platform shall result a default priority being applied. Your chosen priorities shall remain higher in priorities should this occur',
                'Please ensure you keep the original CSV file, in case of data corruption.',
            ];
        case 'numbers':
        default:
            return [
                `CSV upload is limited to a maximum of ${appConfig.csvLimit} items per upload.`,
                'Number IDs and Telephone Numbers cannot be edited. Overstamp Numbers are not validated. ',
                'Please provide the correct address description for importing.',
                'Please ensure you keep the original CSV file, in case of data corruption.',
            ];
    }
};

export const getPlatformName = (platform) => {
    switch (platform) {
        case 'Microsoft Teams Users':
            return (
                <Text>
                    Assign Direct Routing or Operator Connect Phone numbers to
                    Microsoft Teams users. For Direct Routing select from
                    available Voice Routing Policies and Dial Plans. Click{' '}
                    <a
                        style={{ color: '#3182ce' }}
                        href="https://learn.microsoft.com/en-us/microsoftteams/here-s-what-you-get-with-phone-system"
                        target="_blank"
                        rel="noopener noreferrer">
                        here
                    </a>{' '}
                    to learn more about Teams Phone features.
                </Text>
            );
        case 'Microsoft Resource Account':
            return (
                <Text>
                    Assign Direct Routing or Operator Connect Phone numbers to
                    Microsoft Teams.{' '}
                    <a
                        style={{ color: '#3182ce' }}
                        href="https://learn.microsoft.com/en-us/microsoftteams/manage-resource-accounts"
                        target="_blank"
                        rel="noopener noreferrer">
                        Resource Accounts
                    </a>{' '}
                    used for Teams Calling features such Auto Attendants and
                    Call Queues.
                </Text>
            );
        case 'Microsoft Resource Account GCC High':
            return (
                <Text>
                    Assign Direct Routing or Operator Connect Phone numbers to
                    Microsoft Teams GCC High.{' '}
                    <a
                        style={{ color: '#3182ce' }}
                        href="https://learn.microsoft.com/en-us/microsoftteams/manage-resource-accounts"
                        target="_blank"
                        rel="noopener noreferrer">
                        Resource Accounts
                    </a>{' '}
                    used for Teams Calling features such Auto Attendants and
                    Call Queues.
                </Text>
            );
        case 'Microsoft Teams GCC High':
            return (
                <Text>
                    Assign Direct Routing or Operator Connect Phone numbers to
                    Microsoft Teams GCC High. Click{' '}
                    <a
                        style={{ color: '#3182ce' }}
                        href="https://learn.microsoft.com/en-us/microsoftteams/here-s-what-you-get-with-phone-system"
                        target="_blank"
                        rel="noopener noreferrer">
                        here
                    </a>{' '}
                    to learn more about Teams Phone features.
                </Text>
            );
        case 'Zoom':
            return window.location.pathname === '/csv-users' ? (
                <Text>
                    Assign Numbers to Zoom accounts to enable them for Zoom
                    Phone. Click
                    <a
                        style={{ color: '#3182ce' }}
                        href="https://learn.microsoft.com/en-us/microsoftteams/manage-resource-accounts"
                        target="_blank"
                        rel="noopener noreferrer">
                        here
                    </a>
                    to learn more about Zoom Phone features.
                </Text>
            ) : (
                <>
                    <Text marginBottom={4}>
                        Activate numbers for Zoom Phone. Numbers will be
                        uploaded to Zoom and can be assigned via TCAP Resources
                        &gt; Users.
                    </Text>
                    <Text>
                        Click{' '}
                        <a
                            style={{ color: '#3182ce' }}
                            href="https://support.zoom.com/hc/en/category?id=kb_category&kb_category=aac43ed28720391089a37408dabb35f9"
                            target="_blank"
                            rel="noopener noreferrer">
                            here
                        </a>{' '}
                        to learn more about Zoom Phone features
                    </Text>
                </>
            );
        case 'Numbers':
            return (
                <>
                    <Text>
                        Define platform common number settings. Set Address
                        information, Caller ID and customer attributes. Please
                        note, to manage calling services per number, please
                        select the appropriate platform from the above list
                    </Text>
                </>
            );
        case 'Priority':
            return (
                <>
                    <Text marginBottom={4}>
                        Define the priority of each Platform Number. Priority
                        determines inbound call route when multiple options are
                        available. The first active platform defined for a
                        number shall be the default route for all inbound calls.
                    </Text>
                    <Text marginBottom={4}>
                        Define the priority per platform per number. The lower
                        the number, the higher the priority to receive the call.
                    </Text>
                    <Text>
                        Please note, it is possible to set the same priority on
                        multiple platforms per number, however Simultaneous Ring
                        and Failover support shall only be applied if this is
                        enabled on your account.
                    </Text>
                </>
            );
        case 'Microsoft Teams':
            return (
                <>
                    <Text marginBottom={4}>
                        Activate numbers with Direct Routing or Operator Connect
                        for Microsoft Teams. Numbers uploaded to Operator
                        Connect must be assigned an appropriate Calling Profile
                        and Usage Type.
                    </Text>
                    <Text>
                        Click{' '}
                        <a
                            style={{ color: '#3182ce' }}
                            href="https://learn.microsoft.com/en-us/microsoftteams/here-s-what-you-get-with-phone-system"
                            target="_blank"
                            rel="noopener noreferrer">
                            here
                        </a>{' '}
                        to learn more about Teams Phone features.
                    </Text>
                </>
            );
        case 'SBCaaS':
            return window.location.pathname === '/csv-users' ? (
                <></>
            ) : (
                <>
                    <Text marginBottom={4}>
                        Connect SIP services to your company. This enables you
                        to connect your numbers to legacy and other cloud-based
                        SIP platforms via TCAP managed trunks
                    </Text>
                </>
            );
        case 'Microsoft Acs':
            return (
                <Text>
                    Activate numbers for Direct Routing via Azure Communication
                    Services for integration into ACS integrated third party
                    systems
                </Text>
            );
        case 'RingCentral':
            return window.location.pathname.includes('csv-users') ? (
                <Text>
                    Assign phone numbers to Ring Central users. Manage number
                    assignments across your Ring Central platform.
                </Text>
            ) : (
                <Text>
                    Activate numbers for Ring Central. Manage Ring Central phone
                    number assignments for your company.
                </Text>
            );
        default:
            return null;
    }
};
